import { render, staticRenderFns } from "./BlackCustomer.vue?vue&type=template&id=202625ce&scoped=true"
import script from "./BlackCustomer.vue?vue&type=script&lang=js"
export * from "./BlackCustomer.vue?vue&type=script&lang=js"
import style0 from "./BlackCustomer.vue?vue&type=style&index=0&id=202625ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202625ce",
  null
  
)

export default component.exports